export type PtBrCalculatorCategory =
  | "Matemática e Álgebra"
  | "Notas e Educação"
  | "Finanças e Dia a Dia"
  | "Saúde e Boa Forma"
  | "Unidades e Física"
  | "Conversão e Geometria"
  | "Estatística e Dados"
  | "Engenharia e Eletrônica"
  | "Química e Ciência"
  | "Negócios e Produtividade";

export interface PtBrCalculatorMeta {
  slug: string;
  enSlug: string;
  name: string;
  tagline: string;
  description: string;
  category: PtBrCalculatorCategory;
  icon: string;
  featured?: boolean;
  keywords: string[];
}

export const PT_BR_CALCULATOR_CATEGORIES: PtBrCalculatorCategory[] = [
  "Matemática e Álgebra",
  "Notas e Educação",
  "Finanças e Dia a Dia",
  "Saúde e Boa Forma",
  "Unidades e Física",
  "Conversão e Geometria",
  "Estatística e Dados",
  "Engenharia e Eletrônica",
  "Química e Ciência",
  "Negócios e Produtividade",
];

export const PT_BR_CALCULATORS: PtBrCalculatorMeta[] = [
  {
    slug: "matrix-calculator",
    enSlug: "matrix-calculator",
    name: "Calculadora de Matrix",
    tagline: "Calculadora de Matrix online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Matrix. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Grid",
    featured: true,
    keywords: ["calculadora de matrix","matrix calculator","matrix calculator","calculadora online gratis"],
  },
  {
    slug: "logarithm-calculator",
    enSlug: "logarithm-calculator",
    name: "Calculadora de Logarithm & Exponential",
    tagline: "Calculadora de Logarithm & Exponential online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Logarithm & Exponential. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["calculadora de logarithm & exponential","logarithm & exponential calculator","logarithm calculator","calculadora online gratis"],
  },
  {
    slug: "lcm-gcd-calculator",
    enSlug: "lcm-gcd-calculator",
    name: "Calculadora de LCM & GCD (HCF)",
    tagline: "Calculadora de LCM & GCD (HCF) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de LCM & GCD (HCF). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Hash",
    featured: true,
    keywords: ["calculadora de lcm & gcd (hcf)","lcm & gcd (hcf) calculator","lcm gcd calculator","calculadora online gratis"],
  },
  {
    slug: "trigonometry-calculator",
    enSlug: "trigonometry-calculator",
    name: "Solucionador de Trigonometry & Right Triangle",
    tagline: "Solucionador de Trigonometry & Right Triangle online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Solucionador de Trigonometry & Right Triangle. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Compass",
    featured: true,
    keywords: ["solucionador de trigonometry & right triangle","trigonometry & right triangle solver","trigonometry calculator","calculadora online gratis"],
  },
  {
    slug: "sequence-calculator",
    enSlug: "sequence-calculator",
    name: "Calculadora de Sequence & Series (AP & GP)",
    tagline: "Calculadora de Sequence & Series (AP & GP) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Sequence & Series (AP & GP). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "ListOrdered",
    featured: true,
    keywords: ["calculadora de sequence & series (ap & gp)","sequence & series calculator (ap & gp)","sequence calculator","calculadora online gratis"],
  },
  {
    slug: "percentage-calculator",
    enSlug: "percentage-calculator",
    name: "Calculadora de Percentage",
    tagline: "Calculadora de Percentage online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Percentage. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Percent",
    featured: true,
    keywords: ["calculadora de percentage","percentage calculator","percentage calculator","calculadora online gratis"],
  },
  {
    slug: "grade-calculator",
    enSlug: "grade-calculator",
    name: "Calculadora de Grade & GPA",
    tagline: "Calculadora de Grade & GPA online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Grade & GPA. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Notas e Educação",
    icon: "GraduationCap",
    featured: true,
    keywords: ["calculadora de grade & gpa","grade & gpa calculator","grade calculator","calculadora online gratis"],
  },
  {
    slug: "fraction-to-percent-calculator",
    enSlug: "fraction-to-percent-calculator",
    name: "Calculadora de Fraction to Percent",
    tagline: "Calculadora de Fraction to Percent online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Fraction to Percent. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["calculadora de fraction to percent","fraction to percent calculator","fraction to percent calculator","calculadora online gratis"],
  },
  {
    slug: "attendance-calculator",
    enSlug: "attendance-calculator",
    name: "Calculadora de Attendance Percentage",
    tagline: "Calculadora de Attendance Percentage online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Attendance Percentage. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Notas e Educação",
    icon: "UserCheck",
    featured: true,
    keywords: ["calculadora de attendance percentage","attendance percentage calculator","attendance calculator","calculadora online gratis"],
  },
  {
    slug: "discount-calculator",
    enSlug: "discount-calculator",
    name: "Calculadora de Discount & Sales Tax",
    tagline: "Calculadora de Discount & Sales Tax online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Discount & Sales Tax. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Tag",
    featured: true,
    keywords: ["calculadora de discount & sales tax","discount & sales tax calculator","discount calculator","calculadora online gratis"],
  },
  {
    slug: "age-calculator",
    enSlug: "age-calculator",
    name: "Calculadora de Exact Age & Birthday",
    tagline: "Calculadora de Exact Age & Birthday online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Exact Age & Birthday. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Calendar",
    featured: true,
    keywords: ["calculadora de exact age & birthday","exact age & birthday calculator","age calculator","calculadora online gratis"],
  },
  {
    slug: "ratio-calculator",
    enSlug: "ratio-calculator",
    name: "Calculadora de Ratio & Proportion",
    tagline: "Calculadora de Ratio & Proportion online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Ratio & Proportion. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Scale",
    featured: true,
    keywords: ["calculadora de ratio & proportion","ratio & proportion calculator","ratio calculator","calculadora online gratis"],
  },
  {
    slug: "average-calculator",
    enSlug: "average-calculator",
    name: "Calculadora de Average, Median & Mode",
    tagline: "Calculadora de Average, Median & Mode online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Average, Median & Mode. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "BarChart3",
    featured: true,
    keywords: ["calculadora de average, median & mode","average, median & mode calculator","average calculator","calculadora online gratis"],
  },
  {
    slug: "tip-calculator",
    enSlug: "tip-calculator",
    name: "Calculadora de Tip & Bill Splitter",
    tagline: "Calculadora de Tip & Bill Splitter online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Tip & Bill Splitter. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Receipt",
    featured: true,
    keywords: ["calculadora de tip & bill splitter","tip & bill splitter calculator","tip calculator","calculadora online gratis"],
  },
  {
    slug: "time-calculator",
    enSlug: "time-calculator",
    name: "Calculadora de Time & Work Hours",
    tagline: "Calculadora de Time & Work Hours online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Time & Work Hours. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Clock",
    featured: true,
    keywords: ["calculadora de time & work hours","time & work hours calculator","time calculator","calculadora online gratis"],
  },
  {
    slug: "bmi-calculator",
    enSlug: "bmi-calculator",
    name: "Calculadora de BMI & Ideal Weight",
    tagline: "Calculadora de BMI & Ideal Weight online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de BMI & Ideal Weight. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "HeartPulse",
    featured: true,
    keywords: ["calculadora de bmi & ideal weight","bmi & ideal weight calculator","bmi calculator","calculadora online gratis"],
  },
  {
    slug: "interest-calculator",
    enSlug: "interest-calculator",
    name: "Calculadora de Simple & Compound Interest",
    tagline: "Calculadora de Simple & Compound Interest online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Simple & Compound Interest. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "TrendingUp",
    featured: true,
    keywords: ["calculadora de simple & compound interest","simple & compound interest calculator","interest calculator","calculadora online gratis"],
  },
  {
    slug: "cgpa-calculator",
    enSlug: "cgpa-calculator",
    name: "Calculadora de CGPA to Percentage",
    tagline: "Calculadora de CGPA to Percentage online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de CGPA to Percentage. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Notas e Educação",
    icon: "Award",
    featured: true,
    keywords: ["calculadora de cgpa to percentage","cgpa to percentage calculator","cgpa calculator","calculadora online gratis"],
  },
  {
    slug: "scientific-notation-calculator",
    enSlug: "scientific-notation-calculator",
    name: "Calculadora de Scientific Notation",
    tagline: "Calculadora de Scientific Notation online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Scientific Notation. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Atom",
    featured: true,
    keywords: ["calculadora de scientific notation","scientific notation calculator","scientific notation calculator","calculadora online gratis"],
  },
  {
    slug: "salary-calculator",
    enSlug: "salary-calculator",
    name: "Calculadora de Salary & Hourly Wage",
    tagline: "Calculadora de Salary & Hourly Wage online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Salary & Hourly Wage. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Wallet",
    featured: true,
    keywords: ["calculadora de salary & hourly wage","salary & hourly wage calculator","salary calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-target-calculator",
    enSlug: "gpa-target-calculator",
    name: "Calculadora de Target GPA",
    tagline: "Calculadora de Target GPA online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Target GPA. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Notas e Educação",
    icon: "Target",
    featured: true,
    keywords: ["calculadora de target gpa","target gpa calculator","gpa target calculator","calculadora online gratis"],
  },
  {
    slug: "loan-calculator",
    enSlug: "loan-calculator",
    name: "Calculadora de Loan Monthly Payment",
    tagline: "Calculadora de Loan Monthly Payment online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Loan Monthly Payment. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "CreditCard",
    featured: true,
    keywords: ["calculadora de loan monthly payment","loan monthly payment calculator","loan calculator","calculadora online gratis"],
  },
  {
    slug: "word-count-calculator",
    enSlug: "word-count-calculator",
    name: "Calculadora de Word & Character Count",
    tagline: "Calculadora de Word & Character Count online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Word & Character Count. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Notas e Educação",
    icon: "FileText",
    featured: true,
    keywords: ["calculadora de word & character count","word & character count calculator","word count calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-to-percentage-calculator",
    enSlug: "gpa-to-percentage-calculator",
    name: "Conversor de GPA to Percentage",
    tagline: "Conversor de GPA to Percentage online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Conversor de GPA to Percentage. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Notas e Educação",
    icon: "GraduationCap",
    featured: true,
    keywords: ["conversor de gpa to percentage","gpa to percentage converter","gpa to percentage calculator","calculadora online gratis"],
  },
  {
    slug: "pythagorean-theorem-calculator",
    enSlug: "pythagorean-theorem-calculator",
    name: "Calculadora de Pythagorean Theorem",
    tagline: "Calculadora de Pythagorean Theorem online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Pythagorean Theorem. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Triangle",
    featured: true,
    keywords: ["calculadora de pythagorean theorem","pythagorean theorem calculator","pythagorean theorem calculator","calculadora online gratis"],
  },
  {
    slug: "quadratic-formula-calculator",
    enSlug: "quadratic-formula-calculator",
    name: "Solucionador de Quadratic Equation",
    tagline: "Solucionador de Quadratic Equation online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Solucionador de Quadratic Equation. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Variable",
    featured: true,
    keywords: ["solucionador de quadratic equation","quadratic equation solver","quadratic formula calculator","calculadora online gratis"],
  },
  {
    slug: "fuel-cost-calculator",
    enSlug: "fuel-cost-calculator",
    name: "Calculadora de Fuel Cost & Gas Mileage",
    tagline: "Calculadora de Fuel Cost & Gas Mileage online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Fuel Cost & Gas Mileage. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Fuel",
    featured: true,
    keywords: ["calculadora de fuel cost & gas mileage","fuel cost & gas mileage calculator","fuel cost calculator","calculadora online gratis"],
  },
  {
    slug: "margin-calculator",
    enSlug: "margin-calculator",
    name: "Calculadora de Profit Margin & Markup",
    tagline: "Calculadora de Profit Margin & Markup online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Profit Margin & Markup. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "DollarSign",
    featured: true,
    keywords: ["calculadora de profit margin & markup","profit margin & markup calculator","margin calculator","calculadora online gratis"],
  },
  {
    slug: "pace-calculator",
    enSlug: "pace-calculator",
    name: "Calculadora de Running Pace & Speed",
    tagline: "Calculadora de Running Pace & Speed online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Running Pace & Speed. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Timer",
    featured: true,
    keywords: ["calculadora de running pace & speed","running pace & speed calculator","pace calculator","calculadora online gratis"],
  },
  {
    slug: "calorie-calculator",
    enSlug: "calorie-calculator",
    name: "Calculadora de Daily Calorie & BMR",
    tagline: "Calculadora de Daily Calorie & BMR online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Daily Calorie & BMR. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Flame",
    featured: true,
    keywords: ["calculadora de daily calorie & bmr","daily calorie & bmr calculator","calorie calculator","calculadora online gratis"],
  },
  {
    slug: "water-intake-calculator",
    enSlug: "water-intake-calculator",
    name: "Calculadora de Daily Water Intake",
    tagline: "Calculadora de Daily Water Intake online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Daily Water Intake. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Droplets",
    featured: true,
    keywords: ["calculadora de daily water intake","daily water intake calculator","water intake calculator","calculadora online gratis"],
  },
  {
    slug: "body-fat-calculator",
    enSlug: "body-fat-calculator",
    name: "Calculadora de Body Fat Percentage",
    tagline: "Calculadora de Body Fat Percentage online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Body Fat Percentage. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Activity",
    featured: true,
    keywords: ["calculadora de body fat percentage","body fat percentage calculator","body fat calculator","calculadora online gratis"],
  },
  {
    slug: "velocity-acceleration-calculator",
    enSlug: "velocity-acceleration-calculator",
    name: "Calculadora de Speed, Velocity & Acceleration",
    tagline: "Calculadora de Speed, Velocity & Acceleration online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Speed, Velocity & Acceleration. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Unidades e Física",
    icon: "Zap",
    featured: true,
    keywords: ["calculadora de speed, velocity & acceleration","speed, velocity & acceleration calculator","velocity acceleration calculator","calculadora online gratis"],
  },
  {
    slug: "density-calculator",
    enSlug: "density-calculator",
    name: "Calculadora de Density, Mass & Volume",
    tagline: "Calculadora de Density, Mass & Volume online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Density, Mass & Volume. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Unidades e Física",
    icon: "Box",
    featured: true,
    keywords: ["calculadora de density, mass & volume","density, mass & volume calculator","density calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-to-letter-calculator",
    enSlug: "gpa-to-letter-calculator",
    name: "Conversor de Percentage to Letter Grade",
    tagline: "Conversor de Percentage to Letter Grade online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Conversor de Percentage to Letter Grade. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Notas e Educação",
    icon: "CheckCircle2",
    featured: true,
    keywords: ["conversor de percentage to letter grade","percentage to letter grade converter","gpa to letter calculator","calculadora online gratis"],
  },
  {
    slug: "ideal-weight-calculator",
    enSlug: "ideal-weight-calculator",
    name: "Calculadora de Ideal Body Weight (IBW)",
    tagline: "Calculadora de Ideal Body Weight (IBW) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Ideal Body Weight (IBW). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Heart",
    featured: true,
    keywords: ["calculadora de ideal body weight (ibw)","ideal body weight (ibw) calculator","ideal weight calculator","calculadora online gratis"],
  },
  {
    slug: "macro-calculator",
    enSlug: "macro-calculator",
    name: "Calculadora de Macronutrient Ratio",
    tagline: "Calculadora de Macronutrient Ratio online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Macronutrient Ratio. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Apple",
    featured: true,
    keywords: ["calculadora de macronutrient ratio","macronutrient ratio calculator","macro calculator","calculadora online gratis"],
  },
  {
    slug: "weight-loss-calculator",
    enSlug: "weight-loss-calculator",
    name: "Calculadora de Weight Loss & Target Date Planner",
    tagline: "Calculadora de Weight Loss & Target Date Planner online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Weight Loss & Target Date Planner. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "TrendingDown",
    featured: true,
    keywords: ["calculadora de weight loss & target date planner","weight loss calculator & target date planner","weight loss calculator","calculadora online gratis"],
  },
  {
    slug: "height-calculator",
    enSlug: "height-calculator",
    name: "Calculadora de Child & Adult Height Predictor",
    tagline: "Calculadora de Child & Adult Height Predictor online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Child & Adult Height Predictor. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Ruler",
    featured: true,
    keywords: ["calculadora de child & adult height predictor","child & adult height predictor calculator","height calculator","calculadora online gratis"],
  },
  {
    slug: "height-comparison-calculator",
    enSlug: "height-comparison-calculator",
    name: "Calculadora de Height Comparison (Side by Side)",
    tagline: "Calculadora de Height Comparison (Side by Side) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Height Comparison (Side by Side). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Ruler",
    featured: true,
    keywords: ["calculadora de height comparison (side by side)","height comparison calculator (side by side)","height comparison calculator","calculadora online gratis"],
  },
  {
    slug: "army-body-fat-calculator",
    enSlug: "army-body-fat-calculator",
    name: "Calculadora de US Army Body Fat",
    tagline: "Calculadora de US Army Body Fat online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de US Army Body Fat. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "ShieldCheck",
    featured: true,
    keywords: ["calculadora de us army body fat","us army body fat calculator","army body fat calculator","calculadora online gratis"],
  },
  {
    slug: "keto-calculator",
    enSlug: "keto-calculator",
    name: "Calculadora de Keto Macro & Net Carb",
    tagline: "Calculadora de Keto Macro & Net Carb online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Keto Macro & Net Carb. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Flame",
    featured: true,
    keywords: ["calculadora de keto macro & net carb","keto macro & net carb calculator","keto calculator","calculadora online gratis"],
  },
  {
    slug: "height-percentile-calculator",
    enSlug: "height-percentile-calculator",
    name: "Calculadora de Height Percentile (CDC & WHO)",
    tagline: "Calculadora de Height Percentile (CDC & WHO) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Height Percentile (CDC & WHO). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "BarChart2",
    featured: true,
    keywords: ["calculadora de height percentile (cdc & who)","height percentile calculator (cdc & who)","height percentile calculator","calculadora online gratis"],
  },
  {
    slug: "body-surface-area-calculator",
    enSlug: "body-surface-area-calculator",
    name: "Calculadora de Body Surface Area (BSA)",
    tagline: "Calculadora de Body Surface Area (BSA) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Body Surface Area (BSA). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Square",
    featured: true,
    keywords: ["calculadora de body surface area (bsa)","body surface area (bsa) calculator","body surface area calculator","calculadora online gratis"],
  },
  {
    slug: "total-body-water-calculator",
    enSlug: "total-body-water-calculator",
    name: "Calculadora de Total Body Water (TBW)",
    tagline: "Calculadora de Total Body Water (TBW) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Total Body Water (TBW). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Droplet",
    featured: true,
    keywords: ["calculadora de total body water (tbw)","total body water (tbw) calculator","total body water calculator","calculadora online gratis"],
  },
  {
    slug: "healthy-weight-calculator",
    enSlug: "healthy-weight-calculator",
    name: "Calculadora de Healthy Weight & Range Finder",
    tagline: "Calculadora de Healthy Weight & Range Finder online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Healthy Weight & Range Finder. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Activity",
    featured: true,
    keywords: ["calculadora de healthy weight & range finder","healthy weight calculator & range finder","healthy weight calculator","calculadora online gratis"],
  },
  {
    slug: "ohms-law-calculator",
    enSlug: "ohms-law-calculator",
    name: "Calculadora de Ohm's Law & Power",
    tagline: "Calculadora de Ohm's Law & Power online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Ohm's Law & Power. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Unidades e Física",
    icon: "Cpu",
    featured: true,
    keywords: ["calculadora de ohm's law & power","ohm's law & power calculator","ohms law calculator","calculadora online gratis"],
  },
  {
    slug: "convert-temperature-calculator",
    enSlug: "convert-temperature-calculator",
    name: "Calculadora de Temperature",
    tagline: "Calculadora de Temperature online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Temperature. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Unidades e Física",
    icon: "Thermometer",
    featured: true,
    keywords: ["calculadora de temperature","temperature converter calculator","convert temperature calculator","calculadora online gratis"],
  },
  {
    slug: "simple-interest-calculator",
    enSlug: "simple-interest-calculator",
    name: "Calculadora de Simple Interest Loan & Savings",
    tagline: "Calculadora de Simple Interest Loan & Savings online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Simple Interest Loan & Savings. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Coins",
    featured: true,
    keywords: ["calculadora de simple interest loan & savings","simple interest loan & savings calculator","simple interest calculator","calculadora online gratis"],
  },
  {
    slug: "percentage-error-calculator",
    enSlug: "percentage-error-calculator",
    name: "Calculadora de Percentage Error",
    tagline: "Calculadora de Percentage Error online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Percentage Error. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Percent",
    featured: true,
    keywords: ["calculadora de percentage error","percentage error calculator","percentage error calculator","calculadora online gratis"],
  },
  {
    slug: "length-converter-calculator",
    enSlug: "length-converter-calculator",
    name: "Conversor de Length & Distance",
    tagline: "Conversor de Length & Distance online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Conversor de Length & Distance. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Conversão e Geometria",
    icon: "Ruler",
    featured: true,
    keywords: ["conversor de length & distance","length & distance converter","length converter calculator","calculadora online gratis"],
  },
  {
    slug: "area-calculator",
    enSlug: "area-calculator",
    name: "Calculadora de 2D Surface Area",
    tagline: "Calculadora de 2D Surface Area online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de 2D Surface Area. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Conversão e Geometria",
    icon: "Shapes",
    featured: true,
    keywords: ["calculadora de 2d surface area","2d surface area calculator","area calculator","calculadora online gratis"],
  },
  {
    slug: "volume-3d-calculator",
    enSlug: "volume-3d-calculator",
    name: "Calculadora de 3D Volume",
    tagline: "Calculadora de 3D Volume online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de 3D Volume. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Conversão e Geometria",
    icon: "BoxSelect",
    featured: true,
    keywords: ["calculadora de 3d volume","3d volume calculator","volume 3d calculator","calculadora online gratis"],
  },
  {
    slug: "scientific-calculator",
    enSlug: "scientific-calculator",
    name: "Calculadora de Scientific Function",
    tagline: "Calculadora de Scientific Function online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Scientific Function. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Calculator",
    featured: true,
    keywords: ["calculadora de scientific function","scientific function calculator","scientific calculator","calculadora online gratis"],
  },
  {
    slug: "exponent-calculator",
    enSlug: "exponent-calculator",
    name: "Calculadora de Exponent & Power",
    tagline: "Calculadora de Exponent & Power online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Exponent & Power. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Superscript",
    featured: true,
    keywords: ["calculadora de exponent & power","exponent & power calculator","exponent calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-to-4-scale-calculator",
    enSlug: "gpa-to-4-scale-calculator",
    name: "Conversor de Marks & 5-Point to 4.0 GPA",
    tagline: "Conversor de Marks & 5-Point to 4.0 GPA online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Conversor de Marks & 5-Point to 4.0 GPA. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Notas e Educação",
    icon: "Award",
    featured: true,
    keywords: ["conversor de marks & 5-point to 4.0 gpa","marks & 5-point to 4.0 gpa converter","gpa to 4 scale calculator","calculadora online gratis"],
  },
  {
    slug: "standard-deviation-calculator",
    enSlug: "standard-deviation-calculator",
    name: "Calculadora de Standard Deviation & Variance",
    tagline: "Calculadora de Standard Deviation & Variance online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Standard Deviation & Variance. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Estatística e Dados",
    icon: "BarChart2",
    featured: true,
    keywords: ["calculadora de standard deviation & variance","standard deviation & variance calculator","standard deviation calculator","calculadora online gratis"],
  },
  {
    slug: "probability-calculator",
    enSlug: "probability-calculator",
    name: "Calculadora de Probability & Odds",
    tagline: "Calculadora de Probability & Odds online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Probability & Odds. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Estatística e Dados",
    icon: "PieChart",
    featured: true,
    keywords: ["calculadora de probability & odds","probability & odds calculator","probability calculator","calculadora online gratis"],
  },
  {
    slug: "npr-ncr-calculator",
    enSlug: "npr-ncr-calculator",
    name: "Calculadora de Permutation & Combination (nPr / nCr)",
    tagline: "Calculadora de Permutation & Combination (nPr / nCr) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Permutation & Combination (nPr / nCr). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Estatística e Dados",
    icon: "Binary",
    featured: true,
    keywords: ["calculadora de permutation & combination (npr / ncr)","permutation & combination (npr / ncr) calculator","npr ncr calculator","calculadora online gratis"],
  },
  {
    slug: "resistor-color-code-calculator",
    enSlug: "resistor-color-code-calculator",
    name: "Calculadora de Resistor Color Code",
    tagline: "Calculadora de Resistor Color Code online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Resistor Color Code. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Engenharia e Eletrônica",
    icon: "Cpu",
    featured: true,
    keywords: ["calculadora de resistor color code","resistor color code calculator","resistor color code calculator","calculadora online gratis"],
  },
  {
    slug: "voltage-drop-calculator",
    enSlug: "voltage-drop-calculator",
    name: "Calculadora de Wire Voltage Drop & Size",
    tagline: "Calculadora de Wire Voltage Drop & Size online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Wire Voltage Drop & Size. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Engenharia e Eletrônica",
    icon: "Zap",
    featured: true,
    keywords: ["calculadora de wire voltage drop & size","wire voltage drop & size calculator","voltage drop calculator","calculadora online gratis"],
  },
  {
    slug: "power-factor-calculator",
    enSlug: "power-factor-calculator",
    name: "Calculadora de Power Factor (PF) & kVAR Correction",
    tagline: "Calculadora de Power Factor (PF) & kVAR Correction online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Power Factor (PF) & kVAR Correction. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Engenharia e Eletrônica",
    icon: "Activity",
    featured: true,
    keywords: ["calculadora de power factor (pf) & kvar correction","power factor (pf) & kvar correction calculator","power factor calculator","calculadora online gratis"],
  },
  {
    slug: "molarity-calculator",
    enSlug: "molarity-calculator",
    name: "Calculadora de Molarity & Solution Concentration",
    tagline: "Calculadora de Molarity & Solution Concentration online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Molarity & Solution Concentration. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Química e Ciência",
    icon: "FlaskConical",
    featured: true,
    keywords: ["calculadora de molarity & solution concentration","molarity & solution concentration calculator","molarity calculator","calculadora online gratis"],
  },
  {
    slug: "ph-calculator",
    enSlug: "ph-calculator",
    name: "Calculadora de pH, pOH & Hydrogen Ion [H+]",
    tagline: "Calculadora de pH, pOH & Hydrogen Ion [H+] online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de pH, pOH & Hydrogen Ion [H+]. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Química e Ciência",
    icon: "TestTube",
    featured: true,
    keywords: ["calculadora de ph, poh & hydrogen ion [h+]","ph, poh & hydrogen ion [h+] calculator","ph calculator","calculadora online gratis"],
  },
  {
    slug: "ideal-gas-law-calculator",
    enSlug: "ideal-gas-law-calculator",
    name: "Calculadora de Ideal Gas Law (PV = nRT)",
    tagline: "Calculadora de Ideal Gas Law (PV = nRT) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Ideal Gas Law (PV = nRT). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Química e Ciência",
    icon: "Flame",
    featured: true,
    keywords: ["calculadora de ideal gas law (pv = nrt)","ideal gas law (pv = nrt) calculator","ideal gas law calculator","calculadora online gratis"],
  },
  {
    slug: "roi-calculator",
    enSlug: "roi-calculator",
    name: "Calculadora de ROI (Return on Investment)",
    tagline: "Calculadora de ROI (Return on Investment) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de ROI (Return on Investment). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Negócios e Produtividade",
    icon: "TrendingUp",
    featured: true,
    keywords: ["calculadora de roi (return on investment)","roi (return on investment) calculator","roi calculator","calculadora online gratis"],
  },
  {
    slug: "cpm-calculator",
    enSlug: "cpm-calculator",
    name: "Calculadora de CPM (Cost Per Mille / Thousand)",
    tagline: "Calculadora de CPM (Cost Per Mille / Thousand) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de CPM (Cost Per Mille / Thousand). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Negócios e Produtividade",
    icon: "Target",
    featured: true,
    keywords: ["calculadora de cpm (cost per mille / thousand)","cpm (cost per mille / thousand) calculator","cpm calculator","calculadora online gratis"],
  },
  {
    slug: "breakeven-calculator",
    enSlug: "breakeven-calculator",
    name: "Calculadora de Breakeven Point & Profit Margin",
    tagline: "Calculadora de Breakeven Point & Profit Margin online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Breakeven Point & Profit Margin. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Negócios e Produtividade",
    icon: "DollarSign",
    featured: true,
    keywords: ["calculadora de breakeven point & profit margin","breakeven point & profit margin calculator","breakeven calculator","calculadora online gratis"],
  },
  {
    slug: "mortgage-calculator",
    enSlug: "mortgage-calculator",
    name: "Calculadora de Mortgage & Loan Amortization",
    tagline: "Calculadora de Mortgage & Loan Amortization online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Mortgage & Loan Amortization. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Home",
    featured: true,
    keywords: ["calculadora de mortgage & loan amortization","mortgage & loan amortization calculator","mortgage calculator","calculadora online gratis"],
  },
  {
    slug: "compound-interest-calculator",
    enSlug: "compound-interest-calculator",
    name: "Calculadora de Compound Interest & Savings Growth",
    tagline: "Calculadora de Compound Interest & Savings Growth online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Compound Interest & Savings Growth. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "TrendingUp",
    featured: true,
    keywords: ["calculadora de compound interest & savings growth","compound interest & savings growth calculator","compound interest calculator","calculadora online gratis"],
  },
  {
    slug: "tdee-calculator",
    enSlug: "tdee-calculator",
    name: "Calculadora de TDEE & BMR Calorie",
    tagline: "Calculadora de TDEE & BMR Calorie online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de TDEE & BMR Calorie. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Flame",
    featured: true,
    keywords: ["calculadora de tdee & bmr calorie","tdee & bmr calorie calculator","tdee calculator","calculadora online gratis"],
  },
  {
    slug: "inflation-calculator",
    enSlug: "inflation-calculator",
    name: "Calculadora de Inflation & Purchasing Power",
    tagline: "Calculadora de Inflation & Purchasing Power online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Inflation & Purchasing Power. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "ArrowDownRight",
    featured: true,
    keywords: ["calculadora de inflation & purchasing power","inflation & purchasing power calculator","inflation calculator","calculadora online gratis"],
  },
  {
    slug: "linear-equations-calculator",
    enSlug: "linear-equations-calculator",
    name: "Solucionador de System of Linear Equations",
    tagline: "Solucionador de System of Linear Equations online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Solucionador de System of Linear Equations. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["solucionador de system of linear equations","system of linear equations solver","linear equations calculator","calculadora online gratis"],
  },
  {
    slug: "vector-calculator",
    enSlug: "vector-calculator",
    name: "Calculadora de 2D & 3D Vector Math",
    tagline: "Calculadora de 2D & 3D Vector Math online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de 2D & 3D Vector Math. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Unidades e Física",
    icon: "Compass",
    featured: true,
    keywords: ["calculadora de 2d & 3d vector math","2d & 3d vector math calculator","vector calculator","calculadora online gratis"],
  },
  {
    slug: "auto-loan-calculator",
    enSlug: "auto-loan-calculator",
    name: "Calculadora de Auto Loan & Car Payment",
    tagline: "Calculadora de Auto Loan & Car Payment online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Auto Loan & Car Payment. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Car",
    featured: true,
    keywords: ["calculadora de auto loan & car payment","auto loan & car payment calculator","auto loan calculator","calculadora online gratis"],
  },
  {
    slug: "macro-ratio-calculator",
    enSlug: "macro-ratio-calculator",
    name: "Calculadora de Macronutrient & Meal Ratio",
    tagline: "Calculadora de Macronutrient & Meal Ratio online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Macronutrient & Meal Ratio. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Utensils",
    featured: true,
    keywords: ["calculadora de macronutrient & meal ratio","macronutrient & meal ratio calculator","macro ratio calculator","calculadora online gratis"],
  },
  {
    slug: "percentage-change-calculator",
    enSlug: "percentage-change-calculator",
    name: "Calculadora de Percentage Change & Difference",
    tagline: "Calculadora de Percentage Change & Difference online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Percentage Change & Difference. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Percent",
    featured: true,
    keywords: ["calculadora de percentage change & difference","percentage change & difference calculator","percentage change calculator","calculadora online gratis"],
  },
  {
    slug: "fire-calculator",
    enSlug: "fire-calculator",
    name: "Calculadora de FIRE & Retirement Nest Egg",
    tagline: "Calculadora de FIRE & Retirement Nest Egg online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de FIRE & Retirement Nest Egg. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Flame",
    featured: true,
    keywords: ["calculadora de fire & retirement nest egg","fire & retirement nest egg calculator","fire calculator","calculadora online gratis"],
  },
  {
    slug: "loan-payoff-calculator",
    enSlug: "loan-payoff-calculator",
    name: "Calculadora de Loan Payoff & Extra Payment",
    tagline: "Calculadora de Loan Payoff & Extra Payment online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Loan Payoff & Extra Payment. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Sparkles",
    featured: true,
    keywords: ["calculadora de loan payoff & extra payment","loan payoff & extra payment calculator","loan payoff calculator","calculadora online gratis"],
  },
  {
    slug: "kinetic-energy-calculator",
    enSlug: "kinetic-energy-calculator",
    name: "Calculadora de Kinetic Energy & Momentum Physics",
    tagline: "Calculadora de Kinetic Energy & Momentum Physics online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Kinetic Energy & Momentum Physics. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Unidades e Física",
    icon: "Zap",
    featured: true,
    keywords: ["calculadora de kinetic energy & momentum physics","kinetic energy & momentum physics calculator","kinetic energy calculator","calculadora online gratis"],
  },
  {
    slug: "sales-tax-calculator",
    enSlug: "sales-tax-calculator",
    name: "Calculadora de Sales Tax & Reverse Tax",
    tagline: "Calculadora de Sales Tax & Reverse Tax online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Sales Tax & Reverse Tax. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Tag",
    featured: true,
    keywords: ["calculadora de sales tax & reverse tax","sales tax & reverse tax calculator","sales tax calculator","calculadora online gratis"],
  },
  {
    slug: "restaurant-tip-calculator",
    enSlug: "restaurant-tip-calculator",
    name: "Calculadora de Restaurant Tip & Bill Splitter",
    tagline: "Calculadora de Restaurant Tip & Bill Splitter online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Restaurant Tip & Bill Splitter. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Utensils",
    featured: true,
    keywords: ["calculadora de restaurant tip & bill splitter","restaurant tip & bill splitter calculator","restaurant tip calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-conversion-calculator",
    enSlug: "gpa-conversion-calculator",
    name: "Calculadora de GPA, CGPA & 10-Point Scale Conversion",
    tagline: "Calculadora de GPA, CGPA & 10-Point Scale Conversion online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de GPA, CGPA & 10-Point Scale Conversion. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Notas e Educação",
    icon: "Award",
    featured: true,
    keywords: ["calculadora de gpa, cgpa & 10-point scale conversion","gpa, cgpa & 10-point scale conversion calculator","gpa conversion calculator","calculadora online gratis"],
  },
  {
    slug: "calorie-deficit-calculator",
    enSlug: "calorie-deficit-calculator",
    name: "Calculadora de Calorie Deficit & Weight Loss Target Date",
    tagline: "Calculadora de Calorie Deficit & Weight Loss Target Date online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Calorie Deficit & Weight Loss Target Date. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Target",
    featured: true,
    keywords: ["calculadora de calorie deficit & weight loss target date","calorie deficit & weight loss target date calculator","calorie deficit calculator","calculadora online gratis"],
  },
  {
    slug: "quadratic-solver-calculator",
    enSlug: "quadratic-solver-calculator",
    name: "Solucionador de Quadratic Equation & Parabola Vertex",
    tagline: "Solucionador de Quadratic Equation & Parabola Vertex online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Solucionador de Quadratic Equation & Parabola Vertex. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["solucionador de quadratic equation & parabola vertex","quadratic equation & parabola vertex solver","quadratic solver calculator","calculadora online gratis"],
  },
  {
    slug: "work-power-calculator",
    enSlug: "work-power-calculator",
    name: "Calculadora de Work, Power & Horsepower Physics",
    tagline: "Calculadora de Work, Power & Horsepower Physics online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Work, Power & Horsepower Physics. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Unidades e Física",
    icon: "Zap",
    featured: true,
    keywords: ["calculadora de work, power & horsepower physics","work, power & horsepower physics calculator","work power calculator","calculadora online gratis"],
  },
  {
    slug: "mortgage-refinance-calculator",
    enSlug: "mortgage-refinance-calculator",
    name: "Calculadora de Mortgage Refinance & Break-Even",
    tagline: "Calculadora de Mortgage Refinance & Break-Even online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Mortgage Refinance & Break-Even. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "RefreshCw",
    featured: true,
    keywords: ["calculadora de mortgage refinance & break-even","mortgage refinance & break-even calculator","mortgage refinance calculator","calculadora online gratis"],
  },
  {
    slug: "ideal-body-weight-calculator",
    enSlug: "ideal-body-weight-calculator",
    name: "Calculadora de Ideal Body Weight (IBW)",
    tagline: "Calculadora de Ideal Body Weight (IBW) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Ideal Body Weight (IBW). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "HeartPulse",
    featured: true,
    keywords: ["calculadora de ideal body weight (ibw)","ideal body weight (ibw) calculator","ideal body weight calculator","calculadora online gratis"],
  },
  {
    slug: "fraction-arithmetic-calculator",
    enSlug: "fraction-arithmetic-calculator",
    name: "Calculadora de Fraction & Mixed Number Arithmetic",
    tagline: "Calculadora de Fraction & Mixed Number Arithmetic online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Fraction & Mixed Number Arithmetic. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["calculadora de fraction & mixed number arithmetic","fraction & mixed number arithmetic calculator","fraction arithmetic calculator","calculadora online gratis"],
  },
  {
    slug: "cagr-calculator",
    enSlug: "cagr-calculator",
    name: "Calculadora de Compound Annual Growth Rate (CAGR)",
    tagline: "Calculadora de Compound Annual Growth Rate (CAGR) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Compound Annual Growth Rate (CAGR). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Negócios e Produtividade",
    icon: "TrendingUp",
    featured: true,
    keywords: ["calculadora de compound annual growth rate (cagr)","compound annual growth rate (cagr) calculator","cagr calculator","calculadora online gratis"],
  },
  {
    slug: "wave-speed-calculator",
    enSlug: "wave-speed-calculator",
    name: "Calculadora de Wavelength, Frequency & Wave Speed Physics",
    tagline: "Calculadora de Wavelength, Frequency & Wave Speed Physics online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Wavelength, Frequency & Wave Speed Physics. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Unidades e Física",
    icon: "Activity",
    featured: true,
    keywords: ["calculadora de wavelength, frequency & wave speed physics","wavelength, frequency & wave speed physics calculator","wave speed calculator","calculadora online gratis"],
  },
  {
    slug: "dti-calculator",
    enSlug: "dti-calculator",
    name: "Calculadora de Debt-to-Income (DTI) Ratio",
    tagline: "Calculadora de Debt-to-Income (DTI) Ratio online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Debt-to-Income (DTI) Ratio. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "ShieldCheck",
    featured: true,
    keywords: ["calculadora de debt-to-income (dti) ratio","debt-to-income (dti) ratio calculator","dti calculator","calculadora online gratis"],
  },
  {
    slug: "paycheck-calculator",
    enSlug: "paycheck-calculator",
    name: "Calculadora de Paycheck & Take-Home Pay",
    tagline: "Calculadora de Paycheck & Take-Home Pay online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Paycheck & Take-Home Pay. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Wallet",
    featured: true,
    keywords: ["calculadora de paycheck & take-home pay","paycheck & take-home pay calculator","paycheck calculator","calculadora online gratis"],
  },
  {
    slug: "water-retention-calculator",
    enSlug: "water-retention-calculator",
    name: "Calculadora de Water Weight & Fluid Retention",
    tagline: "Calculadora de Water Weight & Fluid Retention online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Water Weight & Fluid Retention. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Droplets",
    featured: true,
    keywords: ["calculadora de water weight & fluid retention","water weight & fluid retention calculator","water retention calculator","calculadora online gratis"],
  },
  {
    slug: "polynomial-calculator",
    enSlug: "polynomial-calculator",
    name: "Calculadora de Polynomial & Synthetic Division",
    tagline: "Calculadora de Polynomial & Synthetic Division online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Polynomial & Synthetic Division. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["calculadora de polynomial & synthetic division","polynomial solver & synthetic division calculator","polynomial calculator","calculadora online gratis"],
  },
  {
    slug: "car-depreciation-calculator",
    enSlug: "car-depreciation-calculator",
    name: "Calculadora de Car Depreciation & Resale Value",
    tagline: "Calculadora de Car Depreciation & Resale Value online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Car Depreciation & Resale Value. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Car",
    featured: true,
    keywords: ["calculadora de car depreciation & resale value","car depreciation & resale value calculator","car depreciation calculator","calculadora online gratis"],
  },
  {
    slug: "weighted-gpa-calculator",
    enSlug: "weighted-gpa-calculator",
    name: "Calculadora de Weighted vs Unweighted GPA",
    tagline: "Calculadora de Weighted vs Unweighted GPA online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Weighted vs Unweighted GPA. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Notas e Educação",
    icon: "GraduationCap",
    featured: true,
    keywords: ["calculadora de weighted vs unweighted gpa","weighted vs unweighted gpa calculator","weighted gpa calculator","calculadora online gratis"],
  },
  {
    slug: "torque-calculator",
    enSlug: "torque-calculator",
    name: "Calculadora de Torque & Rotational Dynamics Physics",
    tagline: "Calculadora de Torque & Rotational Dynamics Physics online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Torque & Rotational Dynamics Physics. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Unidades e Física",
    icon: "RotateCw",
    featured: true,
    keywords: ["calculadora de torque & rotational dynamics physics","torque & rotational dynamics physics calculator","torque calculator","calculadora online gratis"],
  },
  {
    slug: "half-life-calculator",
    enSlug: "half-life-calculator",
    name: "Calculadora de Radioactive Half-Life & Decay",
    tagline: "Calculadora de Radioactive Half-Life & Decay online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Radioactive Half-Life & Decay. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Química e Ciência",
    icon: "Atom",
    featured: true,
    keywords: ["calculadora de radioactive half-life & decay","radioactive half-life & decay calculator","half life calculator","calculadora online gratis"],
  },
  {
    slug: "amortization-schedule-calculator",
    enSlug: "amortization-schedule-calculator",
    name: "Calculadora de Loan & Mortgage Amortization Schedule",
    tagline: "Calculadora de Loan & Mortgage Amortization Schedule online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Loan & Mortgage Amortization Schedule. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Table",
    featured: true,
    keywords: ["calculadora de loan & mortgage amortization schedule","loan & mortgage amortization schedule calculator","amortization schedule calculator","calculadora online gratis"],
  },
  {
    slug: "bmi-percentile-calculator",
    enSlug: "bmi-percentile-calculator",
    name: "Calculadora de Child & Teen BMI Percentile (CDC & WHO)",
    tagline: "Calculadora de Child & Teen BMI Percentile (CDC & WHO) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Child & Teen BMI Percentile (CDC & WHO). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "HeartPulse",
    featured: true,
    keywords: ["calculadora de child & teen bmi percentile (cdc & who)","child & teen bmi percentile calculator (cdc & who)","bmi percentile calculator","calculadora online gratis"],
  },
  {
    slug: "matrix-determinant-calculator",
    enSlug: "matrix-determinant-calculator",
    name: "Calculadora de Matrix Determinant & Transpose",
    tagline: "Calculadora de Matrix Determinant & Transpose online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Matrix Determinant & Transpose. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Grid",
    featured: true,
    keywords: ["calculadora de matrix determinant & transpose","matrix determinant & transpose calculator","matrix determinant calculator","calculadora online gratis"],
  },
  {
    slug: "calories-burned-calculator",
    enSlug: "calories-burned-calculator",
    name: "Calculadora de Exercise Calories Burned & MET",
    tagline: "Calculadora de Exercise Calories Burned & MET online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Exercise Calories Burned & MET. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Saúde e Boa Forma",
    icon: "Flame",
    featured: true,
    keywords: ["calculadora de exercise calories burned & met","exercise calories burned & met calculator","calories burned calculator","calculadora online gratis"],
  },
  {
    slug: "electricity-cost-calculator",
    enSlug: "electricity-cost-calculator",
    name: "Calculadora de Appliance Electricity & Power Cost",
    tagline: "Calculadora de Appliance Electricity & Power Cost online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Appliance Electricity & Power Cost. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Finanças e Dia a Dia",
    icon: "Zap",
    featured: true,
    keywords: ["calculadora de appliance electricity & power cost","appliance electricity & power cost calculator","electricity cost calculator","calculadora online gratis"],
  },
  {
    slug: "dilution-calculator",
    enSlug: "dilution-calculator",
    name: "Calculadora de Solution Dilution (C₁V₁ = C₂V₂)",
    tagline: "Calculadora de Solution Dilution (C₁V₁ = C₂V₂) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Solution Dilution (C₁V₁ = C₂V₂). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Química e Ciência",
    icon: "FlaskConical",
    featured: true,
    keywords: ["calculadora de solution dilution (c₁v₁ = c₂v₂)","solution dilution calculator (c₁v₁ = c₂v₂)","dilution calculator","calculadora online gratis"],
  },
  {
    slug: "rc-circuit-calculator",
    enSlug: "rc-circuit-calculator",
    name: "Calculadora de RC Circuit Time Constant (τ = R·C)",
    tagline: "Calculadora de RC Circuit Time Constant (τ = R·C) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de RC Circuit Time Constant (τ = R·C). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Engenharia e Eletrônica",
    icon: "Cpu",
    featured: true,
    keywords: ["calculadora de rc circuit time constant (τ = r·c)","rc circuit time constant (τ = r·c) calculator","rc circuit calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-semester-calculator",
    enSlug: "gpa-semester-calculator",
    name: "Calculadora de Semester & Term GPA",
    tagline: "Calculadora de Semester & Term GPA online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Semester & Term GPA. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Notas e Educação",
    icon: "GraduationCap",
    featured: true,
    keywords: ["calculadora de semester & term gpa","semester & term gpa calculator","gpa semester calculator","calculadora online gratis"],
  },
  {
    slug: "stoichiometry-calculator",
    enSlug: "stoichiometry-calculator",
    name: "Calculadora de Stoichiometry & Theoretical Yield",
    tagline: "Calculadora de Stoichiometry & Theoretical Yield online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Stoichiometry & Theoretical Yield. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Química e Ciência",
    icon: "FlaskConical",
    featured: true,
    keywords: ["calculadora de stoichiometry & theoretical yield","stoichiometry & theoretical yield calculator","stoichiometry calculator","calculadora online gratis"],
  },
  {
    slug: "logic-gate-calculator",
    enSlug: "logic-gate-calculator",
    name: "Calculadora de Boolean Logic Gate & Truth Table Generator",
    tagline: "Calculadora de Boolean Logic Gate & Truth Table Generator online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Boolean Logic Gate & Truth Table Generator. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Engenharia e Eletrônica",
    icon: "Cpu",
    featured: true,
    keywords: ["calculadora de boolean logic gate & truth table generator","boolean logic gate & truth table generator","logic gate calculator","calculadora online gratis"],
  },
  {
    slug: "ellipse-calculator",
    enSlug: "ellipse-calculator",
    name: "Calculadora de Ellipse Area, Perimeter & Foci",
    tagline: "Calculadora de Ellipse Area, Perimeter & Foci online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Ellipse Area, Perimeter & Foci. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Conversão e Geometria",
    icon: "Shapes",
    featured: true,
    keywords: ["calculadora de ellipse area, perimeter & foci","ellipse area, perimeter & foci calculator","ellipse calculator","calculadora online gratis"],
  },
  {
    slug: "buffer-ph-calculator",
    enSlug: "buffer-ph-calculator",
    name: "Calculadora de Henderson-Hasselbalch Buffer pH",
    tagline: "Calculadora de Henderson-Hasselbalch Buffer pH online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Henderson-Hasselbalch Buffer pH. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Química e Ciência",
    icon: "TestTube",
    featured: true,
    keywords: ["calculadora de henderson-hasselbalch buffer ph","henderson-hasselbalch buffer ph calculator","buffer ph calculator","calculadora online gratis"],
  },
  {
    slug: "led-resistor-calculator",
    enSlug: "led-resistor-calculator",
    name: "Calculadora de LED Series Current Limiting Resistor",
    tagline: "Calculadora de LED Series Current Limiting Resistor online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de LED Series Current Limiting Resistor. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Engenharia e Eletrônica",
    icon: "Zap",
    featured: true,
    keywords: ["calculadora de led series current limiting resistor","led series current limiting resistor calculator","led resistor calculator","calculadora online gratis"],
  },
  {
    slug: "gpa-raise-calculator",
    enSlug: "gpa-raise-calculator",
    name: "Calculadora de GPA Raising & Target Goal",
    tagline: "Calculadora de GPA Raising & Target Goal online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de GPA Raising & Target Goal. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Notas e Educação",
    icon: "Target",
    featured: true,
    keywords: ["calculadora de gpa raising & target goal","gpa raising & target goal calculator","gpa raise calculator","calculadora online gratis"],
  },
  {
    slug: "polynomial-roots-calculator",
    enSlug: "polynomial-roots-calculator",
    name: "Calculadora de Polynomial Roots & Quadratic/Cubic Factoring",
    tagline: "Calculadora de Polynomial Roots & Quadratic/Cubic Factoring online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Polynomial Roots & Quadratic/Cubic Factoring. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Matemática e Álgebra",
    icon: "Binary",
    featured: true,
    keywords: ["calculadora de polynomial roots & quadratic/cubic factoring","polynomial roots & quadratic/cubic factoring calculator","polynomial roots calculator","calculadora online gratis"],
  },
  {
    slug: "decibel-calculator",
    enSlug: "decibel-calculator",
    name: "Calculadora de Decibel (dB) Sound & Power Gain",
    tagline: "Calculadora de Decibel (dB) Sound & Power Gain online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Decibel (dB) Sound & Power Gain. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Engenharia e Eletrônica",
    icon: "Volume2",
    featured: true,
    keywords: ["calculadora de decibel (db) sound & power gain","decibel (db) sound & power gain calculator","decibel calculator","calculadora online gratis"],
  },
  {
    slug: "empirical-formula-calculator",
    enSlug: "empirical-formula-calculator",
    name: "Calculadora de Empirical & Molecular Formula Chemistry",
    tagline: "Calculadora de Empirical & Molecular Formula Chemistry online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Empirical & Molecular Formula Chemistry. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Química e Ciência",
    icon: "FlaskConical",
    featured: true,
    keywords: ["calculadora de empirical & molecular formula chemistry","empirical & molecular formula chemistry calculator","empirical formula calculator","calculadora online gratis"],
  },
  {
    slug: "customer-lifetime-value-calculator",
    enSlug: "customer-lifetime-value-calculator",
    name: "Calculadora de Customer Lifetime Value (LTV / CLV)",
    tagline: "Calculadora de Customer Lifetime Value (LTV / CLV) online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Customer Lifetime Value (LTV / CLV). Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Negócios e Produtividade",
    icon: "Users",
    featured: true,
    keywords: ["calculadora de customer lifetime value (ltv / clv)","customer lifetime value (ltv / clv) calculator","customer lifetime value calculator","calculadora online gratis"],
  },
  {
    slug: "freelance-hourly-rate-calculator",
    enSlug: "freelance-hourly-rate-calculator",
    name: "Calculadora de Freelance Hourly & Daily Rate",
    tagline: "Calculadora de Freelance Hourly & Daily Rate online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Freelance Hourly & Daily Rate. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Negócios e Produtividade",
    icon: "Briefcase",
    featured: true,
    keywords: ["calculadora de freelance hourly & daily rate","freelance hourly & daily rate calculator","freelance hourly rate calculator","calculadora online gratis"],
  },
  {
    slug: "employee-turnover-cost-calculator",
    enSlug: "employee-turnover-cost-calculator",
    name: "Calculadora de Employee Turnover & Replacement Cost",
    tagline: "Calculadora de Employee Turnover & Replacement Cost online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Employee Turnover & Replacement Cost. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Negócios e Produtividade",
    icon: "UserMinus",
    featured: true,
    keywords: ["calculadora de employee turnover & replacement cost","employee turnover & replacement cost calculator","employee turnover cost calculator","calculadora online gratis"],
  },
  {
    slug: "customer-acquisition-cost-calculator",
    enSlug: "customer-acquisition-cost-calculator",
    name: "Calculadora de Customer Acquisition Cost (CAC) & Payback",
    tagline: "Calculadora de Customer Acquisition Cost (CAC) & Payback online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Customer Acquisition Cost (CAC) & Payback. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Negócios e Produtividade",
    icon: "Target",
    featured: true,
    keywords: ["calculadora de customer acquisition cost (cac) & payback","customer acquisition cost (cac) & payback calculator","customer acquisition cost calculator","calculadora online gratis"],
  },
  {
    slug: "working-capital-calculator",
    enSlug: "working-capital-calculator",
    name: "Calculadora de Working Capital & Current Ratio",
    tagline: "Calculadora de Working Capital & Current Ratio online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Working Capital & Current Ratio. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Negócios e Produtividade",
    icon: "Landmark",
    featured: true,
    keywords: ["calculadora de working capital & current ratio","working capital & current ratio calculator","working capital calculator","calculadora online gratis"],
  },
  {
    slug: "email-open-rate-click-through-calculator",
    enSlug: "email-open-rate-click-through-calculator",
    name: "Calculadora de Email Marketing Open Rate, CTR & Campaign ROI",
    tagline: "Calculadora de Email Marketing Open Rate, CTR & Campaign ROI online e grátis. Cálculo instantâneo com fórmulas e soluções passo a passo.",
    description: "Calcule facilmente com a Calculadora de Email Marketing Open Rate, CTR & Campaign ROI. Ferramenta gratuita online sem cadastro e com 100% de privacidade no navegador.",
    category: "Negócios e Produtividade",
    icon: "Mail",
    featured: true,
    keywords: ["calculadora de email marketing open rate, ctr & campaign roi","email marketing open rate, ctr & campaign roi calculator","email open rate click through calculator","calculadora online gratis"],
  },
];

export function getPtBrCalculatorBySlug(slug: string): PtBrCalculatorMeta | undefined {
  return PT_BR_CALCULATORS.find((c) => c.slug === slug || c.enSlug === slug);
}

export function getEnCalculatorSlugForPtBrSlug(ptSlug: string): string {
  const found = PT_BR_CALCULATORS.find((c) => c.slug === ptSlug || c.enSlug === ptSlug);
  return found ? found.enSlug : ptSlug;
}

export function getPtBrCalculatorSlugForEnSlug(enSlug: string): string {
  const found = PT_BR_CALCULATORS.find((c) => c.enSlug === enSlug || c.slug === enSlug);
  return found ? found.slug : enSlug;
}

export function relatedPtBrCalculators(currentSlug: string, count = 4): PtBrCalculatorMeta[] {
  const current = getPtBrCalculatorBySlug(currentSlug);
  return PT_BR_CALCULATORS.filter((c) => c.slug !== current?.slug).slice(0, count);
}
